<template>
  <a-form-model
    class="custom-menu-form"
    layout="vertical"
    ref="customMenuForm"
    :model="form"
    :rules="rules"
    @submit="handleSubmit"
  >
    <a-form-model-item prop="customMenuName">
      <!-- 场景名称 -->
      <a-row type="flex" :gutter="24">
        <a-col required>
          <span class="system-menu-form__menus-name" style="line-height:32px">{{$t('form-modal.customMenuName')}}：</span>
        </a-col>
        <a-col flex="auto">
          <a-input
            v-model="form.customMenuName"
            :placeholder="i18nRender('form-modal.menuname.placeholder')"
            style="width:320px"
          />
        </a-col>
      </a-row>
    </a-form-model-item>

    <a-form-model-item prop="menuIds">
      <a-checkbox-group v-model="form.menuIds">
        <template v-for="(menu, index) in menusOptions">
          <a-divider :key="`_${menu.key}`" v-if="index" />
          <a-row :gutter="24" :key="menu.key">
            <a-col span="4">
              <span class="system-menu-form__menus-name">{{ menu.menuName[currentLang] || menu.tab }}</span>
            </a-col>
            <a-col span="20">
              <a-checkbox
                v-for="pane in menu.options"
                name="menuIds"
                :key="pane.key"
                :value="pane.menuId"
                :disabled="form.menuIds.length >= 15 && form.menuIds.indexOf(pane.menuId) === -1"
                :style="{ marginBottom: '4px' }"
              >
                <span :title="pane.menuName[currentLang] || pane.tab">{{ pane.menuName[currentLang] || pane.tab }}</span>
              </a-checkbox>
            </a-col>
          </a-row>
        </template>
      </a-checkbox-group>
    </a-form-model-item>
    <a-form-model-item prop="remark" style="margin-bottom:0;">
      <a-input
        v-model="form.remark"
        type="textarea"
        :placeholder="i18nRender('form-modal.remark.placeholder')"
      />
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { filterPane } from '@/store/_util/util'
import { i18nRender } from '@/locales'

export default {
  name: 'CustomMenuForm',
  props: {
    menus: {
      type: Array,
      default: () => []
    },
    formData: {
      type: Object,
      default: () => {}
    },
    selectMenusLength: {
      type: Number,
      default: 0
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  computed: {
    menusOptions () {
      const { menus } = this
      const arr = menus.map(menu => {
        const { key, tab, childMenus, menuName, menuEnName, menuKrName } = menu
        const options = filterPane(childMenus || [], { lastMenu: 2 })

        return {
          key,
          tab,
          options,
          menuName,
          menuEnName,
          menuKrName
        }
      })
      return arr
    }
  },
  watch: {
    formData: {
      handler: 'init',
      immediate: true
    },
    'form.menuIds': {
      handler: 'handleChange',
      immediate: true
    }
  },
  data () {
    return {
      form: {
        customMenuName: '',
        menuIds: [],
        remark: ''
      },
      rules: {
        customMenuName: [
          { required: true, message: this.$t('form-modal.menuname.placeholder'), trigger: 'change' },
          { max: 30, message: this.$t('form-modal.rule.maxstring', [30]), trigger: 'change' }
        ],
        menuIds: [
          { type: 'array', required: true, message: this.$t('form-modal.rule.select', [this.$t('form-modal.system.title')]), trigger: 'change' },
          { type: 'array', max: 15, message: this.$t('form-modal.rule.maxobject', [15]), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    i18nRender,
    init (formData) {
      if (formData) {
        this.form = formData
      }
    },
    handleChange (e) {
      this.$emit('update:selectMenusLength', e.length)
    },
    handleSubmit () {
      const {
        $data: { form },
        $refs: { customMenuForm }
      } = this

      return new Promise((resolve, reject) => {
        customMenuForm.validate((valid, callback) => {
          if (valid) {
            resolve({
              ...form,
              type: 1
            })
          } else {
            for (let i of (Object.keys(callback) || [])) {
              this.$notification.warning({
                message: callback[i][0].message
              })
            }
            reject(new Error())
          }
        })
      })
    }
  }
}
</script>

<style lang="less">
  .custom-menu-form {
    .ant-checkbox-wrapper {
      padding-right: 8px;
      width: 25%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:first-child {
        margin-left: 0;
      }

      & + .ant-checkbox-wrapper {
        margin-left: 0;
      }
    }
    // 隐藏校验提示
    .ant-form-explain {
      opacity: 0;
      z-index: -1;
      position: relative;
    }
  }

  .ant-col[required] {
    position: relative;
    &::before {
      content: '*';
      display: block;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      color: rgb(231, 55, 55);
    }
  }

  .custom-menu-form__menus-name {
    display: block;
    padding-left: 10px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;

    &::before {
      content: " ";
      width: 2px;
      height: 12px;
      background: #5681F4;
      border: 1px solid #5681F4;
      border-radius: 2px;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      margin-top: 1px;
    }
  }
</style>
